import App from 'next/app';
import React from 'react';
import { ApolloProvider } from 'react-apollo';
import { createGlobalStyle } from 'styled-components';

import { ThemeProvider } from '../components/Boneyard';

// this also shims fetch...TODO: do this elsewhere
import withApolloClient from '../components/WithApollo';
import ErrorBoundary from '../components/ErrorBoundary';
import { AnalyticsProvider } from '../components/Analytics';
import MaxymiserProvider from '../components/MaxymiserProvider';

import theme from '../theme';
import localSchema from '../localSchema.json';

// By making all the wrappers of Layout full height, we're able
// to push Layout.Footer to the bottom of the viewport
const GlobalStyles = createGlobalStyle`
  html,
  body,
  #__next {
    height: 100%;
  }
`;
class MyApp extends App {
  render() {
    const { Component, pageProps, apolloClient } = this.props;

    return (
      <React.Fragment>
        <GlobalStyles />
        <ErrorBoundary>
          <ApolloProvider client={apolloClient}>
            <MaxymiserProvider>
              <AnalyticsProvider>
                <ThemeProvider theme={theme}>
                  <Component {...pageProps} />
                </ThemeProvider>
              </AnalyticsProvider>
            </MaxymiserProvider>
          </ApolloProvider>
        </ErrorBoundary>
      </React.Fragment>
    );
  }
}

export default withApolloClient({ App: MyApp, schema: localSchema });
